var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPageInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1186.000000, -259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-page-info",
    transform: "translate(1187.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#1495CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(6.500000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.008,9.176 C3.60266667,9.336 3.28,9.45733333 3.038,9.54133333 C2.79666667,9.62533333 2.516,9.66733333 2.19666667,9.66733333 C1.706,9.66733333 1.324,9.54733333 1.052,9.308 C0.78,9.06866667 0.644666667,8.76533333 0.644666667,8.39666667 C0.644666667,8.25333333 0.654666667,8.10666667 0.674666667,7.95733333 C0.695333333,7.808 0.728,7.64 0.772666667,7.45133333 L1.28,5.65933333 C1.32466667,5.48733333 1.36333333,5.324 1.394,5.172 C1.42466667,5.01866667 1.43933333,4.878 1.43933333,4.75 C1.43933333,4.522 1.392,4.362 1.298,4.272 C1.20266667,4.182 1.02333333,4.138 0.756,4.138 C0.625333333,4.138 0.490666667,4.15733333 0.352666667,4.198 C0.216,4.24 0.0973333333,4.278 7.28306304e-14,4.31533333 L0.134,3.76333333 C0.466,3.628 0.784,3.512 1.08733333,3.416 C1.39066667,3.31866667 1.67733333,3.27066667 1.94733333,3.27066667 C2.43466667,3.27066667 2.81066667,3.38933333 3.07533333,3.624 C3.33866667,3.85933333 3.47133333,4.16533333 3.47133333,4.54133333 C3.47133333,4.61933333 3.462,4.75666667 3.444,4.95266667 C3.426,5.14933333 3.392,5.32866667 3.34266667,5.49333333 L2.838,7.28 C2.79666667,7.42333333 2.76,7.58733333 2.72666667,7.77066667 C2.694,7.954 2.678,8.094 2.678,8.188 C2.678,8.42533333 2.73066667,8.58733333 2.83733333,8.67333333 C2.94266667,8.75933333 3.12733333,8.80266667 3.38866667,8.80266667 C3.512,8.80266667 3.65,8.78066667 3.806,8.738 C3.96066667,8.69533333 4.07266667,8.65733333 4.14333333,8.62466667 L4.008,9.176 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91866667,1.924 C3.68333333,2.14266667 3.4,2.252 3.06866667,2.252 C2.738,2.252 2.45266667,2.14266667 2.21533333,1.924 C1.97933333,1.70533333 1.86,1.43933333 1.86,1.12866667 C1.86,0.818666667 1.98,0.552 2.21533333,0.331333333 C2.45266667,0.11 2.738,7.81597009e-14 3.06866667,7.81597009e-14 C3.4,7.81597009e-14 3.684,0.11 3.91866667,0.331333333 C4.154,0.552 4.272,0.818666667 4.272,1.12866667 C4.272,1.44 4.154,1.70533333 3.91866667,1.924 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageInfo);
export default __webpack_public_path__ + "static/media/icon-page-info.ef631a5f1b040bd5c18e815dcc32c656.svg";
export { ForwardRef as ReactComponent };